module.exports = __webpack_public_path__ + "img/8.4bad2d21.png";